<template>
    <carousel class="logos-carousel"
    :items-to-show="1"
    :items-to-scroll="1"
    :mouse-drag="false"
    :autoplay="autoplay"
    :transition="400"
    :wrap-around="true"
    :pause-autoplay-on-hover="true"
    :breakpoints="breakpoints"
    >
    <!-- :snap-align="'start'" -->
      <slide v-for="(logo, index) in logos" :key="index" class="px-[30px]">
        <a :href="logo.link" target="_blank" v-if="logo.link">
          <img :src="logo.logo" alt="logo" class="logo" />
        </a>
          <img :src="logo.logo" alt="logo" class="logo" v-else/>
      </slide>

      <template #addons>
        <Navigation />
      </template>

    </carousel>
</template>

<script>

import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';

export default {
  props: {
    logos: {
      type: Array,
      required: true
    },
    bgColor: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      autoplay: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 3000,
      breakpoints: {
      768: {
        itemsToShow: 3,
        itemsToScroll: 3,
      },
    },
    }
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
}
</script>